import React from 'react'

const FiltrosAdicionados = ({ Filtro }) => (
  <Filtro />
)

export default FiltrosAdicionados
